import { render, staticRenderFns } from "./nawi_linearity_zavorra.vue?vue&type=template&id=66e268b6&"
import script from "./nawi_linearity_zavorra.vue?vue&type=script&lang=js&"
export * from "./nawi_linearity_zavorra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports